import { t } from 'i18next';
import * as yup from 'yup';

import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import { CompanyBasic } from '~hooks/useCompany/models';
import { Material, MaterialTypeItem } from '~hooks/useMaterials/models';
import UserStore from '~store/UserStore';

export const materialSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  company: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .required(t('form_validation_errors.required_simple')),
  type: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .notRequired(),
  externalId: yup.string(),
  isNotActive: yup.boolean(),
});

export type MaterialDto = yup.InferType<typeof materialSchema>;
export type MaterialDtoAsyncError = {
  field: keyof MaterialDto;
  message: string;
};

export const setMaterialSchemaDefaultValues = (
  userStore: UserStore,
  material?: Material,
) => {
  const companyFromStore = userStore.currentCompanies[0] || userStore.user.company;
  const company = material?.company
    ? { label: material.company.legalName, value: material.company.id }
    : companyFromStore
      ? { label: companyFromStore.legalName, value: companyFromStore.id }
      : null;
  const type = material?.type
    ? { label: material.type.name, value: material.type.id }
    : null;

  const defaultValues: MaterialDto = {
    name: material?.name || '',
    company: company as AutocompleteFieldOption<CompanyBasic>,
    type: type as AutocompleteFieldOption<MaterialTypeItem>,
    externalId: material?.externalId || '',
    isNotActive: material?.isNotActive || false,
  };

  return defaultValues;
};
